import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import PageLoader from '../../../../../../component/PageLoader';

export default function PurchaseOrderGeneral({ setError, error, setForm, form, poLoader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	return (
		<div>
			{poLoader.isLoader && poLoader.isGetData ? (
				<PageLoader />
			) : (
				<div className="p-3">
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">
							Enable Auto Creating Purchase Order
						</div>
						<div className="col-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.enable_auto_create_purchase_order}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData(
											'enable_auto_create_purchase_order',
											!form.enable_auto_create_purchase_order,
										)
									}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Terms & Conditions</div>
						<div className="col-xl-6 col-8 my-2">
							<InputField
								type="text"
								value={form?.terms_and_conditions}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('terms_and_conditions', value)}
								error={error?.terms_and_conditions}
								required
								autoComplete="new-terms-and-condition"
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-4 text-sm font-medium text-start">Customer Notes</div>
						<div className="col-xl-6 col-8 my-2">
							<InputField
								type="text"
								value={form?.customer_notes}
								placeholder=""
								label=""
								multiline={true}
								rows={3}
								onChange={(value) => handleFormData('customer_notes', value)}
								error={error?.customer_notes}
								required
								autoComplete="new-customer-notes"
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
